import { Button, styled } from '@clickcease/cc-client-components-lib'

export const DomainSelectWrapper = styled('div', {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  paddingTop: '$10',
  backgroundColor: '$white',
  boxShadow: '0 2px 4px 0 #0000000d',
  borderRadius: '.8em',
  padding: '20px',
})

export const GeneralSelectWrapper = styled('div', {
  display: 'flex',
  alignItems: 'center',
  gap: '30px',
})

export const SingleDomainDisplay = styled('div', {
  color: '$mainTextColor',
  fontWeight: '$sb',
  fontSize: '$m',
  '& label': {
    marginRight: '8px',
    fontWeight: '$l',
    fontSize: '$md',
    lineHeight: '1',
    color: '$fontColor',
  },
})

export const StatusWrapper = styled('div', {
  display: 'flex',
  gap: '10px',
  alignItems: 'inherit',
})

export const StatusText = styled('span', {
  fontSize: '$md',
})

export const GetProtectedButton = styled(Button, {
  fontWeight: '400',
  cursor: 'pointer',
  '& label': {
    cursor: 'pointer',
  },
})

export const ReactToPrintArea = styled('div', {})

export const ReactToPrintButton = styled('button', {
  border: 'none',
  background: 'none',
  outline: 'none',
  color: '$black',
  fontWeight: '$l',
  fontSize: '$md',
  fontFamily: 'inherit',
  cursor: 'pointer',
})

export const DateAndReactToPrintWrapper = styled('div', {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: '20px',
})
